import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=f474dbd6&scoped=true&"
import script from "./commentItem.vue?vue&type=script&lang=js&"
export * from "./commentItem.vue?vue&type=script&lang=js&"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=f474dbd6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474dbd6",
  null
  
)

export default component.exports